import Vue from 'vue'
import Router from 'vue-router'

// import Home from '@/pages/Home'
// import Home2 from '@/pages/Home/index2.vue'
// import List from '@/pages/List'
// import Info from '@/pages/Info'
// import Anime from '@/pages/Anime'
// import Media from '@/pages/Media'
// import MediaList from '@/pages/Media/list.vue'
// import Ranking from '@/pages/Ranking'
// import mine from '@/pages/Mine'
// import Search from '@/pages/Search'
// import VideoInfo from '@/pages/VideoInfo'
// import Live from '@/pages/Live'
// import About from '@/pages/About'

// 路由懒加载
const Home = ()=> import('@/pages/Home')
const Home2 = ()=> import('@/pages/Home/index2.vue')
const List = ()=> import('@/pages/List')
const secondList = ()=> import('@/pages/secondList')
const Info = ()=> import('@/pages/Info')
const Anime = ()=> import('@/pages/Anime')
const Media = ()=> import('@/pages/Media')
const MediaList = ()=> import('@/pages/Media/list.vue')
const Ranking = ()=> import('@/pages/Ranking')
const mine = ()=> import('@/pages/Mine')
const Search = ()=> import('@/pages/Search')
const VideoInfo = ()=> import('@/pages/VideoInfo')
const Live = ()=> import('@/pages/Live')
const About = ()=> import('@/pages/About')

const MineList = ()=> import('@/pages/Mine/MineList.vue')
const Tidings = ()=> import('@/pages/Mine/Tidings.vue')
const Comment = ()=> import('@/pages/Mine/Comment.vue')
const Collection = ()=> import('@/pages/Mine/Collection.vue')
const Praise = ()=> import('@/pages/Mine/Praise.vue')
const ReadingLog = ()=> import('@/pages/Mine/ReadingLog.vue')
const Follow = ()=> import('@/pages/Mine/Follow.vue')
const Preview = ()=> import('@/components/Preview.vue')

const InfoPhantom = ()=> import('@/pages/InfoPhantom')
const Thirdparty = ()=> import('@/pages/Thirdparty')
const appDown = ()=> import('@/pages/appDown')
const Video = ()=> import('@/pages/Video')
const FooterLinks = ()=> import('@/components/FooterLinks.vue')
const OpenScreen = ()=> import('@/pages/OpenScreen')
const peopleLearn = ()=> import('@/pages/peopleLearn/peopleLearn.vue')

const bookChannel = ()=> import('@/pages/bookChannel')
const newBookRecommend = ()=> import('@/pages/bookChannel/newBookRecommend.vue')
const reading = ()=> import('@/pages/bookChannel/reading.vue')
const bookSpecial = ()=> import('@/pages/bookChannel/bookSpecial.vue')
const buyBooksOnline = ()=> import('@/pages/bookChannel/buyBooksOnline.vue')
const zwLiterature = ()=> import('@/pages/bookChannel/zwLiterature.vue')
const readRanking = ()=> import('@/pages/bookChannel/readRanking.vue')
const bookDetail = ()=> import('@/pages/bookChannel/bookDetail.vue')
const everyoneSay = ()=> import('@/pages/bookChannel/everyoneSay.vue')

const parentChildChannel = ()=> import('@/pages/parentChildChannel/index.vue')
const familyConvention = ()=> import('@/pages/parentChildChannel/familyConvention.vue')
const familyLife = ()=> import('@/pages/parentChildChannel/familyLife.vue')
const parentChildTravel = ()=> import('@/pages/parentChildChannel/parentChildTravel.vue')
const parentChildGame = ()=> import('@/pages/parentChildChannel/parentChildGame.vue')
const parentChildTest = ()=> import('@/pages/parentChildChannel/parentChildTest.vue')
const hotActivity = ()=> import('@/pages/parentChildChannel/hotActivity.vue')
const parentChildNews = ()=> import('@/pages/parentChildChannel/parentChildNews.vue')
const wuAClassroom = ()=> import('@/pages/parentChildChannel/wuAClassroom.vue')
const parentChildShow = ()=> import('@/pages/parentChildChannel/parentChildShow.vue')
const parentChildOrganization = ()=> import('@/pages/parentChildChannel/parentChildOrganization.vue')
const encyclopediaOfParenting = ()=> import('@/pages/parentChildChannel/encyclopediaOfParenting.vue')
const parentChildInteract = ()=> import('@/pages/parentChildChannel/parentChildInteract.vue')
const testDetail = ()=> import('@/pages/parentChildChannel/testDetail.vue')
const testing = ()=> import('@/pages/parentChildChannel/testing.vue')
const testResault = ()=> import('@/pages/parentChildChannel/testResault.vue')
const courseDetail = ()=> import('@/pages/parentChildChannel/courseDetail.vue')
const parentChildTravelDetail = ()=> import('@/pages/parentChildChannel/parentChildTravelDetail.vue')
const expertDetail = ()=> import('@/pages/parentChildChannel/expertDetail.vue')
const familyNightSchool = ()=> import('@/pages/parentChildChannel/familyNightSchool.vue')
const parentChildOrganizationDetail = ()=> import('@/pages/parentChildChannel/parentChildOrganizationDetail.vue')

const uploadWorks = ()=> import('@/pages/duomino/uploadWorks.vue')
const dominoIndex = ()=> import('@/pages/duomino/index.vue')
const dominoWorks = ()=> import('@/pages/duomino/dominoWorks.vue')
const worksDetail = ()=> import('@/pages/duomino/worksDetail.vue')
const signUp = ()=> import('@/pages/duomino/signUp.vue')
const agree = ()=> import('@/pages/duomino/agree.vue')
const huaxuVideo = ()=> import('@/pages/duomino/huaxuVideo.vue')
const matchReport = ()=> import('@/pages/duomino/matchReport.vue')
const wonderfulImages = ()=> import('@/pages/duomino/wonderfulImages.vue')

const aged = ()=> import('@/pages/aged/index.vue')
const industryNews = ()=> import('@/pages/aged/industryNews.vue')
const highEndInterview = ()=> import('@/pages/aged/highEndInterview.vue')
const medicalHealthMerge = ()=> import('@/pages/aged/medicalHealthMerge.vue')
const healthTravel = ()=> import('@/pages/aged/healthTravel.vue')
const filialPietySchool = ()=> import('@/pages/aged/filialPietySchool.vue')
const agedRightsProtection = ()=> import('@/pages/aged/agedRightsProtection.vue')
const expertColumn = ()=> import('@/pages/aged/expertColumn.vue')
const webshowCenter = ()=> import('@/pages/aged/webshowCenter.vue')
const agedTalent = ()=> import('@/pages/aged/agedTalent.vue')
const agedMarriage = ()=> import('@/pages/aged/agedMarriage.vue')

const activityTopics = ()=>import('@/pages/activityTopics')
const beautifulCountry = ()=>import('@/pages/activityTopics/beautifulCountry.vue')
const wisdomHealthSeminar = ()=>import('@/pages/activityTopics/wisdomHealthSeminar.vue')
const digitalAgingIndustrySeminar = ()=>import('@/pages/activityTopics/digitalAgingIndustrySeminar.vue')

const pictureIndex = ()=> import('@/pages/pictureChannel')
const explore = ()=> import('@/pages/pictureChannel/explore.vue')
const special = ()=> import('@/pages/pictureChannel/special.vue')
const originalPicture = ()=> import('@/pages/pictureChannel/originalPicture.vue')
const photographers = ()=> import('@/pages/pictureChannel/photographers.vue')
const pictureLive = ()=> import('@/pages/pictureChannel/pictureLive.vue')
const picLiveDetail = ()=> import('@/pages/pictureChannel/picLiveDetail.vue')
const personCenter = ()=> import('@/pages/pictureChannel/personCenter.vue')
const commonPersonCenter = ()=> import('@/pages/pictureChannel/commonPersonCenter.vue')
const picNewsDetail = ()=> import('@/pages/pictureChannel/picNewsDetail.vue')
const picRegister = ()=> import('@/pages/pictureChannel/picRegister.vue')
const createAtlas = ()=> import('@/pages/pictureChannel/createAtlas.vue')
const uploadPicture =()=> import('@/pages/pictureChannel/uploadPicture.vue')
const pictureBuy = ()=> import('@/pages/pictureChannel/pictureBuy.vue')
const atlasDetail = ()=> import('@/pages/pictureChannel/atlasDetail.vue')
const buyProgramme = ()=> import('@/pages/pictureChannel/buyProgramme.vue')
const payForProgramme = ()=> import('@/pages/pictureChannel/payForProgramme.vue')
const searchResult = ()=> import('@/pages/pictureChannel/searchResult.vue')

Vue.use(Router);

export default new Router({
  mode: 'history',
  // base: '/index2/',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/OpenScreen',
      name: 'OpenScreen',
      component: OpenScreen,
      meta: {
        title: '开幕'
      }
    },
    {
      path: '/peopleLearn',
      name: 'peopleLearn',
      component: peopleLearn,
      meta: {
        title: '人民学习'
      }
    },
    {
      path: '/index2.html',
      name: 'Home2',
      component: Home2,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/list',
      name: '资讯列表',
      component: List,
      meta: {
        title: '资讯列表'
      }
    },
    {
      path: '/zixun',
      name: 'zixun',
      component: List,
      meta: {
        title: '资讯',
        queryId: '5e563686e9a5136aeccd175b',
        pageType:'secondChannel'
      }
    },
    {
      path: '/jiaotong',
      name: 'jiaotong',
      component: List,
      meta: {
        title: '交通',
        queryId: '5eb24dee1a760a239c2ea8c8',
        pageType:'secondChannel'
      }
    },
    {
      path: '/bowuguan',
      name: 'bowuguan',
      component: List,
      meta: {
        title: '博物馆',
        queryId: '5eb2554d1a760a0e8c5ca2ed',
        pageType:'secondChannel'
      }
    },
    {
      path: '/guoxue',
      name: 'guoxue',
      component: List,
      meta: {
        title: '国学',
        queryId: '5eb256aa1a760a707c12e954',
        pageType:'secondChannel'
      }
    },
    {
      path: '/dushu',
      name: 'dushu',
      component: bookChannel,
      meta: {
        title: '读书',
        queryId: '5eb257451a760a707c12e955'
      }
    },
    {
      path: '/meishi',
      name: 'meishi',
      component: List,
      meta: {
        title: '美食',
        queryId: '5eb257ba1a760a707c12e956',
        pageType:'secondChannel'
      }
    },

    {
      path: '/caijing',
      name: 'caijing',
      component: List,
      meta: {
        title: '财经',
        queryId: '5e563686e9a5136aeccd175c',
        pageType:'secondChannel'
      }
    },
    {
      path: '/dangjian',
      name: 'dangjian',
      component: List,
      meta: {
        title: '党建',
        queryId: '5e563686e9a5136aeccd175d',
        pageType:'secondChannel'
      }
    },
    {
      path: '/fazhi',
      name: 'fazhi',
      component: List,
      meta: {
        title: '法治',
        queryId: '5e563686e9a5136aeccd175e',
        pageType:'secondChannel'
      }
    },
    {
      path: '/jiaoyu',
      name: 'jiaoyu',
      component: List,
      meta: {
        title: '教育',
        queryId: '5e563686e9a5136aeccd175f',
        pageType:'secondChannel'
      }
    },
    {
      path: '/keji',
      name: 'keji',
      component: List,
      meta: {
        title: '科技',
        queryId: '5e563686e9a5136aeccd1760',
        pageType:'secondChannel'
      }
    },
    {
      path: '/wenhua',
      name: 'wenhua',
      component: List,
      meta: {
        title: '文化',
        queryId: '5e563686e9a5136aeccd1761',
        pageType:'secondChannel'
      }
    },
    {
      path: '/lvyou',
      name: 'lvyou',
      component: List,
      meta: {
        title: '旅游',
        queryId: '5e563686e9a5136aeccd1762',
        pageType:'secondChannel'
      }
    },
    {
      path: '/tiyu',
      name: 'tiyu',
      component: List,
      meta: {
        title: '体育',
        queryId: '5e563686e9a5136aeccd1763',
        pageType:'secondChannel'
      }
    },
    {
      path: '/meitihao',
      name: 'meitihao',
      component: Media,
      meta: {
        title: '媒体号'
      }
    },
    {
      path: '/guofang',
      name: 'guofang',
      component: List,
      meta: {
        title: '国防',
        queryId: '5e563686e9a5136aeccd1764',
        pageType:'secondChannel'
      }
    },
    {
      path: '/nonglin',
      name: 'nonglin',
      component: List,
      meta: {
        title: '农林',
        queryId: '5e563686e9a5136aeccd1765',
        pageType:'secondChannel'
      }
    },
    {
      path: '/jiankang',
      name: 'jiankang',
      component: List,
      meta: {
        title: '健康',
        queryId: '5e563686e9a5136aeccd1766',
        pageType:'secondChannel'
      }
    },
    {
      path: '/gongyi',
      name: 'gongyi',
      component: List,
      meta: {
        title: '公益',
        queryId: '5e563686e9a5136aeccd1767',
        pageType:'secondChannel'
      }
    },
    {
      path: '/yixinyite',
      name: 'yixinyite',
      component: List,
      meta: {
        title: '1县1特',
        queryId: '5e563687234223dcd1721',
        pageType:'secondChannel'
      }
    },
    {
      path: '/shipin',
      name: 'shipin',
      component: List,
      meta: {
        title: '视频',
        queryId: '5e563686e9a5136aeccd1768',
        pageType:'secondChannel'
      }
    },
    {
      path: '/yidaiyilu',
      name: 'yidaiyilu',
      component: List,
      meta: {
        title: '一带一路',
        queryId: '5e563686e9a5136aeccd1769',
        pageType:'secondChannel'
      }
    },
    {
      path: '/youxi',
      name: 'youxi',
      component: List,
      meta: {
        title: '游戏',
        queryId: '5e563686e9a5136aeccd176a',
        pageType:'secondChannel'
      }
    },
    {
      path: '/rongmeiti',
      name: 'rongmeiti',
      component: List,
      meta: {
        title: '融媒体',
        queryId: '5e563686e9a5136aeccd176b',
        pageType:'secondChannel'
      }
    },
    {
      path: '/difang',
      name: 'difang',
      component: List,
      meta: {
        title: '地方',
        queryId: '5e563687e9a5136aeccd176c',
        pageType:'secondChannel'
      }
    },
    {
      path: '/dianshang',
      name: 'dianshang',
      component: List,
      meta: {
        title: '电商',
        queryId: '5e563687e9a5136aeccd176d',
        pageType:'secondChannel'
      }
    },
    {
      path: '/youxi',
      name: 'youxi',
      component: List,
      meta: {
        title: '游戏',
        queryId: '5e563686e9a5136aeccd176a',
        pageType:'secondChannel'
      }
    },
    {
      path: '/zhibo',
      name: 'zhibo',
      component: List,
      meta: {
        title: '直播',
        queryId: '5e563687e9a5136aeccd176e',
        pageType:'secondChannel'
      }
    },
    {
      path: '/fangtan',
      name: 'fangtan',
      component: List,
      meta: {
        title: '访谈',
        queryId: '5e563687e9a5136aeccd176f',
        pageType:'secondChannel'
      }
    },
    {
      path: '/shishang',
      name: 'shishang',
      component: List,
      meta: {
        title: '时尚',
        queryId: '5e563687e9a5136aeccd1770',
        pageType:'secondChannel'
      }
    },
    {
      path: '/fangchan',
      name: 'fangchan',
      component: List,
      meta: {
        title: '房产',
        queryId: '5e563687e9a5136aeccd1771',
        pageType:'secondChannel'
      }
    },
    {
      path: '/qiche',
      name: 'qiche',
      component: List,
      meta: {
        title: '汽车',
        queryId: '5e563687e9a5136aeccd1772',
        pageType:'secondChannel'
      }
    },
    {
      path: '/nvxing',
      name: 'nvxing',
      component: List,
      meta: {
        title: '女性',
        queryId: '5e563687e9a5136aeccd1773',
        pageType:'secondChannel'
      }
    },
    {
      path: '/jiating',
      name: 'jiating',
      component: List,
      meta: {
        title: '家庭',
        queryId: '5e563687e9a5136aeccd1774',
        pageType:'secondChannel'
      }
    },
    {
      path: '/secondList',
      name: 'secondList',
      component: secondList,
      meta: {
        title: '',
        queryId: '',
        pageType:'secondChannel'
      }
    },
    {
      path: '/qinzi',
      name: 'qinzi',
      component: parentChildChannel,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/familyConvention',
      name: 'familyConvention',
      component: familyConvention,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/familyLife',
      name: 'familyLife',
      component: familyLife,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildTravel',
      name: 'parentChildTravel',
      component: parentChildTravel,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildGame',
      name: 'parentChildGame',
      component: parentChildGame,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildTest',
      name: 'parentChildTest',
      component: parentChildTest,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/hotActivity',
      name: 'hotActivity',
      component: hotActivity,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildNews',
      name: 'parentChildNews',
      component: parentChildNews,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/wuAClassroom',
      name: 'wuAClassroom',
      component: wuAClassroom,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildShow',
      name: 'parentChildShow',
      component: parentChildShow,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildOrganization',
      name: 'parentChildOrganization',
      component: parentChildOrganization,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/encyclopediaOfParenting',
      name: 'encyclopediaOfParenting',
      component: encyclopediaOfParenting,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildInteract',
      name: 'parentChildInteract',
      component: parentChildInteract,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/testDetail',
      name: 'testDetail',
      component: testDetail,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/testing',
      name: 'testing',
      component: testing,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/testResault',
      name: 'testResault',
      component: testResault,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      component: courseDetail,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildTravelDetail',
      name: 'parentChildTravelDetail',
      component: parentChildTravelDetail,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/expertDetail',
      name: 'expertDetail',
      component: expertDetail,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/familyNightSchool',
      name: 'familyNightSchool',
      component: familyNightSchool,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/parentChildOrganizationDetail',
      name: 'parentChildOrganizationDetail',
      component: parentChildOrganizationDetail,
      meta: {
        title: '亲子',
        queryId: '5e563687e9a5136aeccd1775'
      }
    },
    {
      path: '/yanglao',
      name: 'yanglao',
      component: aged,
      meta: {
        title: '老龄',
        queryId: '5e563687e9a5136aeccd1776',
        pageType:'secondChannel'
      }
    },
    {
      path: '/xingyekuaibao',
      name: 'industryNews',
      component: industryNews,
      meta: {
        title: '老龄',
        queryId: '5f56e5c3806cccc91c728447',
        pageType:'secondChannel'
      }
    },
    {
      path: '/gaoduanfangtan',
      name: 'highEndInterview',
      component: highEndInterview,
      meta: {
        title: '老龄',
        queryId: '5f56e5c6806cccc91c72844a',
        pageType:'secondChannel'
      }
    },
    {
      path: '/yiyangronghe',
      name: 'medicalHealthMerge',
      component: medicalHealthMerge,
      meta: {
        title: '老龄',
        queryId: '5f56e5c4806cccc91c728448',
        pageType:'secondChannel'
      }
    },
    {
      path: '/kangyanglvyou',
      name: 'healthTravel',
      component: healthTravel,
      meta: {
        title: '老龄',
        queryId: '5f56e5c5806cccc91c728449',
        pageType:'secondChannel'
      }
    },
    {
      path: '/xiaolexuetang',
      name: 'filialPietySchool',
      component: filialPietySchool,
      meta: {
        title: '老龄',
        queryId: '5f56e5c9806cccc91c72844d',
        pageType:'secondChannel'
      }
    },
    {
      path: '/laonianweiquan',
      name: 'agedRightsProtection',
      component: agedRightsProtection,
      meta: {
        title: '老龄',
        queryId: '5f56e5c8806cccc91c72844c',
        pageType:'secondChannel'
      }
    },
    {
      path: '/zhuanjiazhuanlan',
      name: 'expertColumn',
      component: expertColumn,
      meta: {
        title: '老龄',
        queryId: '5f56e5c7806cccc91c72844b',
        pageType:'secondChannel'
      }
    },
    {
      path: '/wangzhanzhongxin',
      name: 'webshowCenter',
      component: webshowCenter,
      meta: {
        title: '老龄',
        queryId: '5f56e5ca806cccc91c72844e',
        pageType:'secondChannel'
      }
    },
    {
      path: '/laonianrencai',
      name: 'agedTalent',
      component: agedTalent,
      meta: {
        title: '老龄',
        queryId: '5f56e5cb806cccc91c72844f',
        pageType:'secondChannel'
      }
    },
    {
      path: '/laonianhunlian',
      name: 'agedMarriage',
      component: agedMarriage,
      meta: {
        title: '老龄',
        queryId: '5f56e5cc806cccc91c728450',
        pageType:'secondChannel'
      }
    },
    {
      path: '/shequ',
      name: 'shequ',
      component: List,
      meta: {
        title: '社区',
        queryId: '5e563687e9a5136aeccd1777',
        pageType:'secondChannel'
      }
    },
    {
      path: '/qiye',
      name: 'qiye',
      component: List,
      meta: {
        title: '企业',
        queryId: '5e563687e9a5136aeccd1778',
        pageType:'secondChannel'
      }
    },
    {
      path: '/zhongyi',
      name: 'zhongyi',
      component: List,
      meta: {
        title: '中医',
        queryId: '5e563687e9a5136aeccd1779',
        pageType:'secondChannel'
      }
    },
    {
      path: '/zhongguozhizao',
      name: 'zhongguozhizao',
      component: List,
      meta: {
        title: '中国制造',
        queryId: '5e563687e9a5136aeccd177a',
        pageType:'secondChannel'
      }
    },
    {
      path: '/zhiku',
      name: 'zhiku',
      component: List,
      meta: {
        title: '智库',
        queryId: '5e563687e9a5136aeccd177b',
        pageType:'secondChannel'
      }
    },
    {
      path: '/donghua',
      name: 'donghua',
      component: List,
      meta: {
        title: '动画',
        queryId: '5eb257ba16342a707c123215',
        pageType:'secondChannel'
      }
    },
    {
      path: '/dianying',
      name: 'dianying',
      component: List,
      meta: {
        title: '电影',
        queryId: '5e56362gwt45136aecc53rwe',
        pageType:'secondChannel'
      }
    },
    {
      path: '/laoqu',
      name: 'laoqu',
      component: List,
      meta: {
        title: '老区',
        queryId: '449gjfefowekfowk92j3fofe',
        pageType:'secondChannel'
      }
    },
    {
      path: '/jilupian',
      name: 'jilupian',
      component: Video,
      meta: {
        title: '纪录片',
        queryId: '5e563687e9a5136aeccd177c'
      }
    },
    {
      path: '/medialist',
      name: 'medialist',
      component: MediaList,
      meta: {
        title: '媒体号列表'
      }
    },
    {
      path: '/info',
      name: '资讯详情',
      component: Info,
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/infoPhantom',
      name: '资讯详情',
      component: InfoPhantom,
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/thirdparty',
      name: '第三方',
      component: Thirdparty,
      meta: {
        title: '第三方'
      }
    },
    {
      path: '/appDown',
      name: '人民互联下载',
      component: appDown,
      meta: {
        title: '人民互联下载'
      }
    },
    {
      path: '/anime',
      name: '动漫短视频',
      component: Anime,
      meta: {
        title: '动漫短视频'
      }
    },
    {
      path: '/videoInfo',
      name: '视频详情',
      component: VideoInfo,
      meta: {
        title: '视频详情'
      }
    },
    {
      path: '/ranking',
      name: '红黑榜',
      component: Ranking,
      meta: {
        title: '红黑榜'
      }
    },
    // {
    //   path: '/bookChannel',
    //   name: 'bookChannel',
    //   component: bookChannel,
    //   meta: {
    //     title: '图书频道',
    //     queryId:'5eb257451a760a707c12e955'
    //   }
    // },
    {
      path: '/newBookRecommend',
      name: 'newBookRecommend',
      component: newBookRecommend,
      meta: {
        title: '新书推荐',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/readHeadlines',
      name: 'readHeadlines',
      component: reading,
      meta: {
        title: '阅读头条',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/readActivity',
      name: 'readActivity',
      component: reading,
      meta: {
        title: '读书活动',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/peopleRead',
      name: 'peopleRead',
      component: reading,
      meta: {
        title: '全民阅读',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/peasantBookRoom',
      name: 'peasantBookRoom',
      component: reading,
      meta: {
        title: '农家书屋',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/editorRecommendation',
      name: 'editorRecommendation',
      component: reading,
      meta: {
        title: '主编推荐',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/bookSpecial',
      name: 'bookSpecial',
      component: bookSpecial,
      meta: {
        title: '图书专题',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/buyBooksOnline',
      name: 'buyBooksOnline',
      component: buyBooksOnline,
      meta: {
        title: '在线购书',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/zwLiterature',
      name: 'zwLiterature',
      // component: zwLiterature,
      component: reading,
      meta: {
        title: '众网文学',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/readRanking',
      name: 'readRanking',
      component: readRanking,
      meta: {
        title: '阅读榜单',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/everyoneSay',
      name: 'everyoneSay',
      component: everyoneSay,
      meta: {
        title: '众说',
        queryId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/bookDetail',
      name: 'bookDetail',
      component: bookDetail,
      meta: {
        title: '商品详情',
        columnId:'5eb257451a760a707c12e955'
      }
    },
    {
      path: '/zhiyejingliren',
      name: 'zhiyejingliren',
      component: List,
      meta: {
        title: '职业经理人',
        columnId:'5eb257451a760a707c12e955',
        pageType:'secondChannel'
      }
    },
    {
      path: '/wanghong',
      name: 'wanghong',
      component: List,
      meta: {
        title: '网红',
        columnId:'5eb257451a760a707c12e955',
        pageType:'secondChannel'
      }
    },
    {
      path: '/dominoIndex',
      name: 'dominoIndex',
      component: dominoIndex,
      meta: {
        title: '多米诺首页',
        columnId:''
      }
    },
    {
      path: '/uploadWorks',
      name: 'uploadWorks',
      component: uploadWorks,
      meta: {
        title: '上传多米诺作品',
        columnId:''
      }
    },
    {
      path: '/dominoWorks',
      name: 'dominoWorks',
      component: dominoWorks,
      meta: {
        title: '多米诺全部作品',
        columnId:''
      }
    },
    {
      path: '/worksDetail',
      name: 'worksDetail',
      component: worksDetail,
      meta: {
        title: '多米诺作品详情',
        columnId:''
      }
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: signUp,
      meta: {
        title: '多米诺报名',
        columnId:''
      }
    },
    {
      path: '/agree',
      name: 'agree',
      component: agree,
      meta: {
        title: '多米诺报名参赛承诺书',
        columnId:''
      }
    },
    {
      path: '/huaxuVideo',
      name: 'huaxuVideo',
      component: huaxuVideo,
      meta: {
        title: '多米诺明星祝福花絮视频',
        columnId:''
      }
    },
    {
      path: '/matchReport',
      name: 'matchReport',
      component: matchReport,
      meta: {
        title: '多米诺赛事报道',
        columnId:''
      }
    },
    {
      path: '/wonderfulImages',
      name: 'wonderfulImages',
      component: wonderfulImages,
      meta: {
        title: '多米诺精彩图片',
        columnId:''
      }
    },
    {
      path:'/activityTopics',
      name:'activityTopics',
      component: activityTopics,
      meta:{
        title: '老年用品和服务标准体系建设研讨会-活动专题页',
        columnId:''
      }
    },
    {
      path:'/beautifulCountry',
      name:'beautifulCountry',
      component: beautifulCountry,
      meta:{
        title: '美丽乡村博鳌国际峰会-活动专题页',
        columnId:''
      }
    },
    {
      path:'/wisdomHealthSeminar',
      name:'wisdomHealthSeminar',
      component: wisdomHealthSeminar,
      meta:{
        title: '智慧康养研讨会-活动专题页',
        columnId:''
      }
    },
    {
      path:'/digitalAgingIndustrySeminar',
      name:'digitalAgingIndustrySeminar',
      component: digitalAgingIndustrySeminar,
      meta:{
        title: '数字化时代老龄产业发展新趋势战略研讨会-活动专题页',
        columnId:''
      }
    },
    {
      path:'/tupianpindao',
      name:'pictureIndex',
      component: pictureIndex,
      meta:{
        title:'图片频道首页',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/explore',
      name:'explore',
      component: explore,
      meta:{
        title:'图片频道-探索',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/special',
      name:'special',
      component: special,
      meta:{
        title:'图片频道-专题',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/picStory',
      name:'picStory',
      component: special,
      meta:{
        title:'图片频道-图片故事',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/fashion',
      name:'fashion',
      component: special,
      meta:{
        title:'图片频道-时尚',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/travel',
      name:'travel',
      component: special,
      meta:{
        title:'图片频道-旅游',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/originalPicture',
      name:'originalPicture',
      component: originalPicture,
      meta:{
        title:'图片频道-原创图库',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/photographers',
      name:'photographers',
      component: photographers,
      meta:{
        title:'图片频道-摄影师',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/pictureLive',
      name:'pictureLive',
      component: pictureLive,
      meta:{
        title:'图片频道-图片直播',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'picHeader'
      }
    },
    {
      path:'/picLiveDetail',
      name:'picLiveDetail',
      component: picLiveDetail,
      meta:{
        title:'图片频道-图片直播详情',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/personCenter',
      name:'personCenter',
      component: personCenter,
      meta:{
        title:'图片频道-摄影师个人中心',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/commonPersonCenter',
      name:'commonPersonCenter',
      component: commonPersonCenter,
      meta:{
        title:'图片频道-普通用户个人中心',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/picNewsDetail',
      name:'picNewsDetail',
      component: picNewsDetail,
      meta:{
        title:'图片频道-图片新闻详情',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/picRegister',
      name:'picRegister',
      component: picRegister,
      meta:{
        title:'图片频道-入驻-认证摄影师',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/createAtlas',
      name:'createAtlas',
      component: createAtlas,
      meta:{
        title:'图片频道-创建图集',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/uploadPicture',
      name:'uploadPicture',
      component: uploadPicture,
      meta:{
        title:'图片频道-上传图片',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/pictureBuy',
      name:'pictureBuy',
      component: pictureBuy,
      meta:{
        title:'图片频道-图片购买',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/atlasDetail',
      name:'atlasDetail',
      component: atlasDetail,
      meta:{
        title:'图片频道-图集详情',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/buyProgramme',
      name:'buyProgramme',
      component: buyProgramme,
      meta:{
        title:'图片频道-购买方案',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/payForProgramme',
      name:'payForProgramme',
      component: payForProgramme,
      meta:{
        title:'图片频道-支付购买方案',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path:'/searchResult',
      name:'searchResult',
      component: searchResult,
      meta:{
        title:'图片频道-图片搜索',
        columnId:'60b47fece98dd1481c05a64f',
        isPicChannel:'yes',
        isHeader:'none'
      }
    },
    {
      path: '/mine',
      name: '个人中心',
      component: mine,
      meta: {
        title: '个人中心',
        login_required: false,
      },
      children: [
        {
          path: '/mine/',
          component: MineList,
          meta: {
            title: '个人中心'
          }
        },
        {
          path: '/mine/mineList',
          component: MineList,
          meta: {
            title: '我的发布'
          }
        },
        {
          path: '/mine/tidings', component: Tidings, meta: {
            title: '我的消息'
          }
        },
        {
          path: '/mine/comment', component: Comment,
          meta: {
            title: '评价管理'
          }
        },
        {
          path: '/mine/collection', component: Collection,
          meta: {
            title: '我的收藏'
          }
        },
        {
          path: '/mine/praise', component: Praise,
          meta: {
            title: '我的赞'
          }
        },
        {
          path: '/mine/readingLog', component: ReadingLog,
          meta: {
            title: '阅读历史'
          }
        },
        {
          path: '/mine/follow', name: 'follow', component: Follow,
          meta: {
            title: '关注粉丝'
          }
        }
      ]
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta: {
        title: '搜索结果'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '/FooterLinks',
      name: 'FooterLinks',
      component: FooterLinks
    },
    {
      path: '/baidu_verify_doby64Lhr2.html',
      name: 'baidu_verify_doby64Lhr2'
    },
    {
      path: '/baidu_verify_h2HGinC3qq.html',
      name: 'baidu_verify_h2HGinC3qq'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js